import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const isBoardSettings = (
    state: IApplicationState
): boolean => {
    const { route, args } = state.router;
    if (
        route !== ERoutes.BOARD_EDIT &&
        route !== ERoutes.BOARD_EDIT_SCROLL &&
        route !== ERoutes.BOARD_ACTIVITY &&
        route !== ERoutes.BOARD_FILTER &&
        route !== ERoutes.BOARD_DESIGN &&
        route !== ERoutes.BOARD_BACKUPS &&
        route !== ERoutes.BOARD_EXPORT &&
        route !== ERoutes.BOARD_COPY
    ) return null;

    const boardId = args[1];

    return !!parseInt(boardId);
}
